import React, { createContext, useState, useContext, useEffect } from 'react';

// Simple translation dictionary
const translations = {
    vi: {
        login: {
            title: "Phanh",
            subtitle: "Hệ thống quản lý đặt lịch",
            username: "Tên đăng nhập",
            email: "Email đăng nhập",
            password: "Mật khẩu",
            loginButton: "Đăng nhập",
            registerButton: "Đăng ký",
            divider: "Hoặc đăng nhập bằng",
            errorMissing: "Vui lòng nhập đầy đủ thông tin",
            errorLoginFailed: "Đăng nhập thất bại",
            placeholderUsername: "Nhập tên đăng nhập",
            placeholderPassword: "Nhập mật khẩu",
            loading: "Đăng nhập..."
        },
        register: {
            title: "Đăng Ký Tài Khoản",
            fullName: "Họ và Tên",
            username: "Tên đăng nhập",
            gender: "Giới tính",
            dob: "Ngày sinh",
            phone: "Số điện thoại",
            email: "Email",
            address: "Địa chỉ",
            password: "Mật khẩu",
            confirmPassword: "Nhập lại mật khẩu",
            policy: "Tôi đồng ý với tất cả điều khoản dịch vụ của ứng dụng",
            submit: "Đăng Ký Ngay",
            submitting: "Đang xử lý...",
            loginLink: "Đã có tài khoản?",
            loginLinkAction: "Đăng nhập ngay",
            male: "Nam",
            female: "Nữ",
            other: "Khác"
        },
        sidebar: {
            dashboard: "Tổng quan",
            bookings: "Lịch hẹn",
            employees: "Nhân viên",
            services: "Dịch vụ",
            customers: "Khách hàng",
            schedule: "Lịch làm việc",
            earnings: "Thu Nhập",
            settings: "Cài đặt",
            profile: "Tài khoản",
            logout: "Đăng xuất",
            openMenu: "Mở menu",
            closeMenu: "Đóng menu"
        },
        dashboard: {
            stats: {
                employees: "Nhân viên",
                today: "Hoạt động hôm nay",
                todayBookings: "Booking hôm nay",
                pendingBookings: "Booking đang chờ",
                revenue: "Doanh thu tháng",
                noData: "Không có dữ liệu thống kê"
            },
            notifications: {
                account_upgraded_pro: "Tài khoản đã nâng cấp Pro",
                plan_updated_basic: "Cập nhật Gói dịch vụ",
                plan_message_pro: "Chúc mừng! Tài khoản của bạn đã được nâng cấp lên gói Pro. Bạn có thể quản lý tối đa 3 doanh nghiệp.",
                plan_message_basic: "Tài khoản của bạn đã được chuyển về gói Basic. Giới hạn quản lý là 1 doanh nghiệp."
            },
            workingEmployees: "Nhân viên đang làm việc",
            recentActivities: "Hoạt động gần đây",
            more: "thêm",
            min: "phút",
            refresh: "Làm mới",
            loading: "Đang tải...",
            actions: {
                addBooking: "Thêm booking",
                onlineBooking: "Booking Online"
            },
            calendar: {
                title: "Lịch hôm nay",
                time: "Giờ",
                bookingsCount: "booking trong ngày"
            },
            empty: {
                noEmployees: "Chưa có nhân viên nào. Vui lòng thêm nhân viên.",
                noActivities: "Chưa có hoạt động nào.",
                unassigned: "Chờ phân công"
            },
            greeting: "Xin chào, {name}",
            error: {
                loadFailed: "Không thể tải dữ liệu dashboard. Vui lòng thử lại.",
                noServices: "Chưa có dịch vụ nào. Vui lòng thêm dịch vụ trước.",
                noBookingCode: "Chưa có mã booking. Vui lòng liên hệ quản trị viên."
            },
            shopName: {
                placeholder: "Nhập tên salon...",
                saveTitle: "Lưu",
                cancelTitle: "Hủy",
                editTitle: "Chỉnh sửa tên salon",
                emptyError: "Tên salon không được để trống",
                saveError: "Không thể lưu tên salon. Vui lòng thử lại."
            },
            businessId: {
                label: "Business ID (chia sẻ cho nhân viên)",
                copySuccess: "Đã copy Business ID!",
                copyPrompt: "Copy ID này:"
            },
            statusOptions: {
                pending: "⏳ Chờ xác nhận",
                confirmed: "✅ Đã xác nhận",
                completed: "🏁 Hoàn thành",
                cancelled: "❌ Đã hủy"
            },
            addBooking: {
                validationName: "Vui lòng nhập tên và số điện thoại khách hàng",
                validationService: "Vui lòng chọn ít nhất một dịch vụ",
                validationEmployee: "Vui lòng chọn nhân viên phụ trách",
                validationBiz: "Không tìm thấy Business ID. Vui lòng đăng nhập lại.",
                success: "✅ Booking đã được tạo thành công!",
                errorOutsideHours: "Hãy chọn giờ khác hoặc kiểm tra Business Hours trong cài đặt.",
                errorNoBiz: "Không tìm thấy Business. Vui lòng đăng xuất và đăng nhập lại.",
                errorGeneric: "❌ Lỗi:",
                selectEmployee: "-- Chọn nhân viên phụ trách --"
            },
            onlineBooking: {
                validationName: "Vui lòng nhập đầy đủ tên và số điện thoại",
                success: "✅ Cảm ơn quý khách đã đặt lịch! Chúng tôi sẽ liên hệ xác nhận sớm.",
                errorGeneric: "❌ Lỗi:",
                errorNoService: "Không thể đặt lịch"
            },
            deleteEmployee: {
                confirm: "Bạn có chắc muốn xóa nhân viên này?",
                success: "✅ Đã xóa nhân viên thành công!",
                errorPrefix: "❌ Lỗi:",
                errorSuffix: "Không thể xóa nhân viên"
            },
            updateStatus: {
                errorPrefix: "❌ Không thể cập nhật:"
            },
            bookingDetail: {
                title: "Chi tiết booking",
                customer: "Khách hàng",
                phone: "Số điện thoại",
                service: "Dịch vụ",
                people: "Số người",
                date: "Ngày",
                time: "Giờ",
                notes: "Ghi chú",
                status: "Trạng thái",
                staff: "Nhân viên",
                unassigned: "Chưa phân công",
                close: "Đóng",
                assign: "Phân công nhân viên",
                save: "Lưu thay đổi",
                attachedImages: "Hình ảnh đính kèm"
            },
            assignModal: {
                title: "Phân công nhân viên",
                selectLabel: "Chọn nhân viên phụ trách",
                unassigned: "— Chưa phân công —",
                willAssign: "✓ Sẽ giao cho:",
                cancel: "Hủy",
                confirm: "💾 Xác nhận phân công",
                today: "Hôm nay",
                assignError: "❌ Lỗi phân công:"
            },
            modals: {
                addBookingTitle: "Thêm booking mới",
                onlineBookingTitle: "Đặt lịch Online",
                labels: {
                    customerName: "Tên khách hàng",
                    phone: "Số điện thoại",
                    email: "Email",
                    employee: "Nhân viên",
                    service: "Dịch vụ",
                    date: "Ngày",
                    time: "Thời gian",
                    people: "Số người",
                    notes: "Ghi chú",
                    attachPhotos: "Đính kèm ảnh tham khảo (Không bắt buộc)"
                },
                placeholders: {
                    customerName: "Nhập tên khách hàng...",
                    phone: "Nhập số điện thoại...",
                    email: "Nhập email...",
                    notes: "Yêu cầu đặc biệt..."
                },
                buttons: {
                    cancel: "Hủy",
                    submit: "Thêm booking",
                    submitOnline: "Đặt lịch",
                    addPhotosLimit: "+ Thêm ảnh (Tối đa 3)"
                },
                publicLink: {
                    title: "Liên kết đặt lịch trực tuyến",
                    description: "Chia sẻ liên kết này với khách hàng của bạn để họ có thể tự đặt lịch.",
                    copyBtn: "Sao chép liên kết",
                    visitBtn: "Xem trang",
                    copySuccess: "Đã sao chép liên kết vào bộ nhớ tạm!"
                }
            }
        },
        onboarding: {
            welcome: "Chào mừng bạn! 👋",
            subtitle: "Để bắt đầu sử dụng, bạn cần tạo doanh nghiệp mới hoặc tham gia một doanh nghiệp đã có.",
            loggedInAs: "Đăng nhập với:",
            logout: "Đăng xuất",
            createCard: {
                title: "Tạo doanh nghiệp mới",
                desc: "Đăng ký doanh nghiệp của riêng bạn và trở thành chủ sở hữu. Bạn có thể mời nhân viên tham gia sau.",
                action: "Bắt đầu tạo"
            },
            joinCard: {
                title: "Nhập mã doanh nghiệp",
                desc: "Bạn đã có mã mời từ chủ doanh nghiệp? Nhập mã để tham gia và làm việc cùng đội ngũ.",
                action: "Nhập mã"
            },
            createForm: {
                title: "Tạo doanh nghiệp mới",
                nameLabel: "Tên doanh nghiệp *",
                namePlaceholder: "VD: Salon Tóc ABC, Spa XYZ...",
                descLabel: "Mô tả (tùy chọn)",
                descPlaceholder: "Mô tả ngắn về doanh nghiệp của bạn...",
                phoneLabel: "Số điện thoại",
                addressLabel: "Địa chỉ",
                addressPlaceholder: "Địa chỉ doanh nghiệp",
                submitLoading: "Đang tạo...",
                submitBtn: "Tạo doanh nghiệp",
                validationName: "Vui lòng nhập tên doanh nghiệp",
                success: "Tạo doanh nghiệp thành công! Đang chuyển hướng...",
                errorDefault: "Không thể tạo doanh nghiệp. Vui lòng thử lại."
            },
            joinForm: {
                title: "Nhập mã doanh nghiệp",
                codeLabel: "Mã doanh nghiệp / Business ID *",
                codePlaceholder: "Nhập Business ID (24 ký tự) hoặc mã ngắn",
                codeHint: "Nhập Business ID đầy đủ (24 ký tự) hoặc mã ngắn từ chủ doanh nghiệp",
                submitLoading: "Đang xác thực...",
                submitBtn: "Tham gia doanh nghiệp",
                validationCode: "Vui lòng nhập mã doanh nghiệp hoặc Business ID",
                success: "Tham gia doanh nghiệp thành công! Đang chuyển hướng...",
                errorInvalid: "Mã không hợp lệ",
                errorDefault: "Mã doanh nghiệp không hợp lệ hoặc đã hết hạn"
            },
            title: "Thiết lập tài khoản",
            createBusiness: "Tạo doanh nghiệp mới",
            joinBusiness: "Tham gia doanh nghiệp",
            joinPlaceholder: "Nhập Business ID...",
            joinBtn: "Tham gia",
            joining: "Đang tham gia...",
            invalidId: "ID không hợp lệ. Vui lòng kiểm tra lại.",
            joinSuccess: "Tham gia thành công!"
        },

        employees: {
            title: "Quản lý nhân viên",
            add: "Thêm nhân viên",
            searchPlaceholder: "Tìm kiếm nhân viên...",
            table: {
                name: "Tên nhân viên",
                position: "Vị trí",
                status: "Trạng thái",
                actions: "Thao tác"
            },
            status: {
                active: "Đang làm việc",
                inactive: "Nghỉ việc"
            },
            noResults: "Không tìm thấy nhân viên nào",
            messages: {
                noPermissionAdd: "Bạn không có quyền thêm nhân viên!",
                enterInfo: "Vui lòng nhập đầy đủ tên và số điện thoại!",
                addSuccess: "Thêm nhân viên thành công!",
                addError: "Không thể thêm nhân viên",
                noPermissionUpdate: "Bạn không có quyền cập nhật nhân viên!",
                updateSuccess: "Cập nhật nhân viên thành công!",
                shiftUpdated: "Cập nhật ca làm việc thành công!",
                updateError: "Không thể cập nhật nhân viên",
                noPermissionDelete: "Bạn không có quyền xóa nhân viên!",
                confirmDelete: "Bạn có chắc muốn xóa nhân viên này?",
                cannotDeleteSelf: "Không thể xóa chính bạn!",
                deleteSuccess: "Xóa nhân viên thành công!",
                deleteError: "Không thể xóa nhân viên",
                noPermissionStatus: "Bạn không có quyền thay đổi trạng thái nhân viên!",
                statusChanged: {
                    active: "Đã kích hoạt nhân viên!",
                    inactive: "Đã vô hiệu hóa nhân viên!"
                },
                statusError: "Không thể thay đổi trạng thái",
                onlyOwnerCanAssignManager: "Chỉ chủ salon mới có thể phân quyền Manager!",
                roleAssigned: "Phân quyền thành công!",
                roleError: "Không thể phân quyền",
                confirmDeleteMember: "Xóa {name} khỏi doanh nghiệp?",
                removeMemberSuccess: "Đã xóa nhân viên",
                deleteErrorPrefix: "Lỗi",
                roleUpdatedTo: "Đã cập nhật quyền thành"
            },
            stats: {
                total: "Tổng nhân viên",
                active: "Đang hoạt động",
                manager: "Quản lý",
                morning: "Ca sáng"
            },
            filters: {
                role: "Vai trò:",
                shift: "Ca làm việc:",
                status: "Trạng thái:",
                searchBtn: "Tìm kiếm",
                allRoles: "Tất cả vai trò",
                allShifts: "Tất cả ca",
                allStatuses: "Tất cả trạng thái"
            },
            loading: "Đang tải dữ liệu...",
            youBadge: "(Bạn)",
            empty: {
                title: "Chưa có nhân viên nào",
                hint1: "Chia sẻ <strong>Business ID</strong> của bạn để nhân viên tham gia.",
                hint2: "Nhân viên vào <strong>Tài khoản → Tham gia doanh nghiệp</strong> và nhập Business ID."
            },
            detailAlert: {
                title: "Chi tiết nhân viên",
                name: "Tên",
                email: "Email",
                phone: "SĐT",
                role: "Vai trò",
                shift: "Ca làm việc",
                joinedAt: "Tham gia"
            },
            modals: {
                addTitle: "Thêm nhân viên mới",
                editTitle: "Chỉnh sửa nhân viên",
                shiftLabel: "Ca làm việc *",
                shiftEditTitle: "Chỉnh ca — ",
                shiftType: "Loại ca",
                shiftStartTime: "Giờ bắt đầu",
                shiftEndTime: "Giờ kết thúc",
                shiftPreview: "Xem trước ca làm việc",
                saveShift: "Lưu ca",
                cancel: "Hủy",
                update: "Cập nhật",
                staffOption: "Nhân viên",
                managerOption: "Quản lý",
                labels: {
                    name: "Tên nhân viên",
                    phone: "Số điện thoại",
                    role: "Vai trò",
                    shift: "Ca làm việc"
                }
            },
            permissions: {
                title: "Thông tin phân quyền",
                owner: {
                    title: "Chủ Salon (Owner)",
                    perm1: "Quản lý tất cả nhân viên",
                    perm2: "Phân quyền Manager",
                    perm3: "Chỉnh sửa thông tin salon",
                    perm4: "Xem tất cả báo cáo"
                },
                manager: {
                    title: "Quản lý (Manager)",
                    perm1: "Quản lý nhân viên (thêm/sửa/xóa)",
                    perm2: "Quản lý booking",
                    perm3: "Quản lý dịch vụ",
                    perm4: "Xem báo cáo"
                },
                staff: {
                    title: "Nhân viên (Staff)",
                    perm1: "Xem danh sách nhân viên",
                    perm2: "Quản lý booking",
                    perm3: "Không thể thêm/sửa nhân viên"
                }
            },
            shifts: {
                morning: "Ca sáng",
                afternoon: "Ca chiều",
                evening: "Ca tối",
                night: "Ca đêm",
                fullTime: "Toàn thời gian",
                partTime: "Bán thời gian"
            }
        },
        bookings: {
            title: "Danh sách lịch hẹn",
            create: "Đặt lịch mới",
            filter: {
                all: "Tất cả",
                pending: "Đang chờ",
                confirmed: "Đã xác nhận",
                completed: "Hoàn thành",
                cancelled: "Đã hủy"
            },
            table: {
                customer: "Khách hàng",
                service: "Dịch vụ",
                date: "Ngày & Giờ",
                staff: "Nhân viên",
                status: "Trạng thái",
                actions: "Thao tác"
            },
            empty: "Không tìm thấy booking nào",
            unassigned: "Chưa phân công",
            messages: {
                updateOffline: "Không thể kết nối server, đã cập nhật local storage",
                confirmDelete: "Bạn có chắc muốn xóa booking này?",
                deleteOffline: "Không thể kết nối server, đã xóa khỏi local storage"
            },
            stats: {
                today: "Hôm nay",
                week: "Tuần này",
                month: "Tháng này",
                total: "Tổng",
                pending: "Chờ xác nhận",
                confirmed: "Đã xác nhận",
                completed: "Đã hoàn thành",
                cancelled: "Đã hủy"
            },
            filters: {
                time: "Thời gian:",
                source: "Nguồn:",
                status: "Trạng thái:",
                searchPlaceholder: "🔍 Tìm kiếm theo tên, SĐT, dịch vụ...",
                reset: "Reset",
                options: {
                    today: "Hôm nay",
                    week: "7 ngày qua",
                    month: "30 ngày qua",
                    all: "Tất cả",
                    allSources: "Tất cả nguồn",
                    online: "Booking Online",
                    manual: "Nhân viên tạo",
                    allStatuses: "Tất cả trạng thái"
                }
            },
            headers: {
                addService: "Thêm dịch vụ mới",
                serviceList: "Danh sách dịch vụ",
                allBookings: "Tất cả booking",
                filteredResults: "Kết quả lọc"
            },
            serviceForm: {
                name: "Tên dịch vụ",
                price: "Giá tiền (VND)",
                color: "Màu sắc hiển thị",
                duration: "Thời gian dự kiến",
                addBtn: "Thêm dịch vụ",
                closeBtn: "Đóng",
                description: "Dịch vụ sẽ hiển thị trên Dashboard và có thể chọn khi tạo booking"
            },
            hints: {
                emptyState: "Thử thay đổi bộ lọc hoặc tạo booking mới",
                autoAssign: "(Tự động khi xác nhận)",
                goToDashboard: "Về Dashboard để tạo booking"
            },
            actions: {
                viewDetails: "Xem chi tiết",
                edit: "Chỉnh sửa",
                delete: "Xóa booking",
                updatePhone: "Cập nhật số điện thoại:"
            },
            modals: {
                checkout: {
                    title: "Xác Nhận Hoàn Thành",
                    subtitle: "Ghi nhận doanh thu trước khi đóng lịch",
                    servicePrice: "Giá Dịch Vụ",
                    tipAmount: "Tiền TIP",
                    totalIncome: "Tổng Thu Nhập",
                    confirmBtn: "Xác Nhận Hoàn Thành"
                }
            },
            summary: {
                title: "Tóm tắt thống kê",
                onlineBookings: "Booking Online:",
                manualBookings: "Booking trực tiếp:",
                completionRate: "Tỷ lệ hoàn thành:",
                cancelRate: "Tỷ lệ hủy:"
            }
        },
        profile: {
            title: "Thông tin tài khoản",
            uploadTitle: "Thay đổi ảnh đại diện",
            labels: {
                fullName: "Họ và Tên",
                address: "Địa chỉ",
                phone: "Số điện thoại",
                dob: "Ngày sinh",
                gender: "Giới tính",
                notUpdated: "Chưa cập nhật"
            },
            buttons: {
                edit: "Chỉnh sửa thông tin",
                cancel: "Hủy bỏ",
                save: "Lưu thay đổi",
                saving: "Đang lưu..."
            },
            business: {
                title: "Doanh nghiệp của tôi",
                add: "Thêm doanh nghiệp mới",
                role: "Chủ sở hữu"
            },
            messages: {
                success: "Cập nhật thông tin thành công!",
                error: "Cập nhật thất bại!",
                genericError: "Đã có lỗi xảy ra"
            }
        },
        services: {
            deletedService: "Dịch vụ đã xóa",
            messages: {
                enterName: "Vui lòng nhập tên dịch vụ",
                addSuccess: "Đã thêm dịch vụ thành công!",
                addOffline: "Không thể kết nối server, đã lưu vào local storage",
                confirmDelete: "Bạn có chắc muốn xóa dịch vụ này?\nLưu ý: Các booking liên quan đến dịch vụ này sẽ không bị xóa nhưng sẽ hiển thị màu mặc định.",
                deleteOffline: "Không thể kết nối server, đã xóa khỏi local storage",
                updateSuccess: "Cập nhật dịch vụ thành công!",
                updateOffline: "Không thể kết nối server, đã lưu vào local storage"
            }
        },
        roles: {
            owner: "Chủ sở hữu",
            manager: "Quản lý",
            staff: "Nhân viên",
            receptionist: "Lễ tân",
            admin: "Admin",
            customer: "Khách hàng"
        },
        shifts: {
            morning: "Ca sáng",
            afternoon: "Ca chiều",
            evening: "Ca tối",
            night: "Ca đêm",
            fulltime: "Toàn thời gian",
            parttime: "Bán thời gian"
        },
        schedule: {
            title: "Quản lý lịch làm việc",
            subtitle: "Phân ca làm việc cho nhân viên",
            dayView: "Ngày",
            weekView: "Tuần",
            date: "Ngày:",
            weekContaining: "Tuần chứa ngày:",
            addEmployee: "Thêm nhân viên vào lịch",
            save: "Lưu lịch",
            saving: "Đang lưu...",
            selectEmployee: "Chọn nhân viên",
            search: "Tìm tên nhân viên...",
            noMembers: "Chưa có nhân viên. Họ cần nhập Business ID để tham gia.",
            allAssigned: "Tất cả nhân viên đã có trong lịch hôm nay.",
            noSchedule: "Chưa có nhân viên nào trong lịch",
            noScheduleHint: "Nhấn \"Thêm nhân viên vào lịch\" để bắt đầu phân công ca.",
            needJoin: "Nhân viên cần nhập Business ID để tham gia doanh nghiệp trước.",
            applyAll: "Áp dụng nhanh cho tất cả:",
            employee: "Nhân viên",
            off: "Nghỉ",
            removeFromSchedule: "Xóa khỏi lịch",
            saveSuccess: "Đã lưu {count} lịch làm việc!",
            saveError: "Lỗi khi lưu lịch",
            loading: "Đang tải...",
            today: "Hôm nay",
            prevDay: "Ngày trước",
            nextDay: "Ngày tiếp",
            prevWeek: "Tuần trước",
            nextWeek: "Tuần tiếp",
            shifts: {
                morning: "Sáng",
                afternoon: "Chiều",
                evening: "Tối",
                fullday: "Cả ngày",
                off: "Nghỉ"
            }
        },
        customers: {
            title: "Khách hàng",
            search: "Tìm khách hàng...",
            add: "Thêm khách hàng",
            total: "Tổng khách hàng",
            new: "Khách mới (tháng này)",
            returning: "Khách quen",
            empty: "Chưa có khách hàng nào",
            notFound: "Không tìm thấy khách hàng",
            loading: "Đang tải...",
            backToList: "← Quay lại danh sách",
            search2: "Tìm theo tên hoặc SĐT...",
            searchBtn: "Tìm kiếm",
            view: "Xem",
            noData: "Không tìm thấy khách hàng nào.",
            contactInfo: "Thông tin liên hệ",
            stats: "Thống kê",
            totalBookings: "Tổng lượt đặt",
            firstVisit: "Lần đầu ghé thăm",
            lastVisit2: "Lần cuối ghé thăm",
            recentBookings: "Lịch hẹn gần đây",
            bookingHistoryPlaceholder: "Lịch sử booking sẽ hiển thị ở đây.",
            table: {
                name: "Họ tên",
                phone: "Số điện thoại",
                email: "Email",
                bookings: "Số lần đặt",
                lastVisit: "Lần cuối",
                actions: "Thao tác"
            }
        },
        business: {
            settings: "Cài đặt doanh nghiệp",
            name: "Tên doanh nghiệp",
            phone: "Số điện thoại",
            email: "Email",
            address: "Địa chỉ",
            hours: "Giờ hoạt động",
            save: "Lưu thay đổi",
            saving: "Đang lưu...",
            saved: "Đã lưu!",
            businessId: "Business ID",
            shareId: "Chia sẻ ID này để nhân viên tham gia",
            loading: "Đang tải...",
            logo: "Logo doanh nghiệp",
            uploadLogo: "Nhấn để tải logo lên",
            uploadLogoHint: "JPG, PNG, WebP · Tối đa 5MB",
            changeLogo: "📷 Đổi Logo",
            uploadingLogo: "Đang tải lên...",
            onlineBookingPage: "Trang Booking Online",
            footerMessage: "Tin nhắn chân trang",
            footerHint: "— hiển thị ở cuối trang booking",
            footerBlankHint: "Để trống sẽ tự dùng số điện thoại doanh nghiệp",
            businessHours: "Giờ hoạt động",
            open: "Mở cửa",
            closed: "Đóng cửa",
            to: "đến",
            settingsUpdated: "Cập nhật cài đặt thành công!",
            settingsError: "Cập nhật cài đặt thất bại.",
            googleMapsHint: "Nhập link Google Maps để khách 5 sao có thể đánh giá trực tiếp. Mã QR của business được tạo tự động từ Booking Code.",
            qrPrintHint: 'ℹ️ In mã QR từ Dashboard → nút "📱 QR Check-in" để dán tại quầy lễ tân'
        },
        checkin: {
            title: "Check-in / Check-out",
            enterPhone: "Nhập số điện thoại",
            phoneHint: "Nhập SĐT bạn đã dùng khi đặt lịch",
            phonePlaceholder: "VD: 0901234567",
            findBooking: "Tìm booking",
            searching: "Đang tìm...",
            bookingFound: "Booking tìm thấy!",
            walkIn: "Walk-in",
            walkInHint: "Không tìm thấy lịch hẹn, nhưng bạn vẫn có thể check-in walk-in.",
            checkinNow: "Check In ngay",
            checkedIn: "Đã Check-in!",
            checkoutHint: "Khi hoàn tất dịch vụ, hãy quét lại QR để check-out và đánh giá.",
            checkout: "Check Out & Đánh giá",
            noBooking: "Không có booking hôm nay cho số điện thoại này.",
            connectionError: "Lỗi kết nối. Vui lòng thử lại.",
            scanAgain: "Quét lại",
            poweredBy: "Powered by Booking App"
        },
        review: {
            title: "Đánh giá dịch vụ",
            hint: "Trải nghiệm của bạn thế nào tại",
            selectStar: "Chọn số sao",
            terrible: "Rất tệ",
            bad: "Tệ",
            average: "Bình thường",
            good: "Tốt",
            excellent: "Tuyệt vời!",
            feedbackPlaceholder: "Góp ý thêm (không bắt buộc)...",
            googleMapsHint: "Đánh giá 5 sao sẽ được đăng lên Google Maps để chia sẻ với mọi người!",
            submitGoogle: "Gửi & Đánh giá Google Maps",
            submit: "Gửi đánh giá",
            submitting: "Đang gửi...",
            thankyou: "Cảm ơn!",
            thankyouMsg: "Chúng tôi đã nhận được đánh giá của bạn và sẽ không ngừng cải thiện dịch vụ.",
            seeYouAgain: "Hẹn gặp lại bạn lần sau!",
            listTitle: "Đánh giá khách hàng",
            listSub: "Feedback nội bộ từ QR Check-out",
            noReviews: "Chưa có đánh giá nào",
            noReviewsHint: "Đánh giá sẽ xuất hiện khi khách check-out và đánh giá.",
            reviews: "đánh giá",
            allRatings: "Tất cả sao",
            staff: "Nhân viên",
            service: "Dịch vụ",
            copyLink: "Copy Link",
            printQR: "In QR",
            qrTitle: "QR Check-in / Check-out",
            qrDesc: "Khách hàng quét mã QR này để check-in khi đến và check-out khi hoàn tất để đánh giá.",
            linkCopied: "Đã copy link!"
        },

        notifications: {
            title: "Thông báo",
            markAllRead: "✓ Đọc hết",
            clearAll: "Xóa tất cả",
            enableBanner: "Bật thông báo để nhận cập nhật booking mới",
            enableBtn: "Bật thông báo",
            empty: "Không có thông báo mới",
            action: "Xem chi tiết →",
            viewAll: "Xem tất cả {count} thông báo →",
            time: {
                justNow: "Vừa xong",
                minsAgo: "{mins} phút trước",
                hoursAgo: "{hours} giờ trước",
                daysAgo: "{days} ngày trước"
            }
        },
        common: {
            loading: "Đang tải...",
            refresh: "Làm mới",
            export: "Xuất dữ liệu",
            na: "Không có"
        },
        earnings: {
            title: "Thu Nhập",
            subtitle: "Theo dõi doanh thu và thống kê công việc",
            chartTitle: "Biểu đồ Thu Nhập",
            exportCSV: "Xuất CSV",
            today: "Hôm nay",
            week: "7 ngày qua",
            month: "Tháng này",
            custom: "Tùy chỉnh",
            from: "Từ",
            to: "Đến",
            totalBusinessRevenue: "Tổng Doanh Thu Tiệm",
            serviceRevenue: "Doanh Thu Dịch Vụ",
            totalTip: "Tổng TIP",
            employeesWithRevenue: "Số Nhân Viên Có Doanh Thu",
            myTotalRevenue: "Tổng Thu Nhập Của Tôi",
            tip: "Tiền TIP",
            completedServices: "Số Dịch Vụ Hoàn Thành",
            fullStatsTitle: "Thống Kê Thu Nhập Toàn Bộ Nhân Viên",
            table: {
                index: "#",
                employee: "Nhân Viên",
                servicesCount: "Số Dịch Vụ",
                serviceRevenue: "Doanh Thu Dịch Vụ",
                tip: "Tiền TIP",
                total: "Tổng Thu Nhập",
                percentTotal: "% Tổng",
                grandTotal: "TỔNG CỘNG"
            },
            noData: "Chưa có dữ liệu doanh thu trong khoảng thời gian này.",
            noDataHint1: "Hãy đánh dấu hoàn thành các booking và nhập giá tiền để xem thống kê.",
            noStaffData: "Bạn chưa có dịch vụ nào hoàn thành trong khoảng thời gian này.",
            noStaffDataHint: "Thu nhập sẽ được ghi nhận khi bạn hoàn thành và nhập giá tiền cho booking."
        }
    },
    en: {
        login: {
            title: "Phanh",
            subtitle: "Booking Management System",
            username: "Username",
            email: "Email address",
            password: "Password",
            loginButton: "Login",
            registerButton: "Register",
            divider: "Or login with",
            errorMissing: "Please enter all fields",
            errorLoginFailed: "Login failed",
            placeholderUsername: "Enter username",
            placeholderPassword: "Enter password",
            loading: "Logging in..."
        },
        register: {
            title: "Create Account",
            fullName: "Full Name",
            username: "Username",
            gender: "Gender",
            dob: "Date of Birth",
            phone: "Phone Number",
            email: "Email",
            address: "Address",
            password: "Password",
            confirmPassword: "Confirm Password",
            policy: "I agree to all terms of service of the application",
            submit: "Register Now",
            submitting: "Processing...",
            loginLink: "Already have an account?",
            loginLinkAction: "Login now",
            male: "Male",
            female: "Female",
            other: "Other"
        },
        sidebar: {
            dashboard: "Dashboard",
            bookings: "Bookings",
            employees: "Employees",
            services: "Services",
            customers: "Customers",
            schedule: "Schedule",
            earnings: "Earnings",
            settings: "Settings",
            profile: "Profile",
            logout: "Logout",
            openMenu: "Open menu",
            closeMenu: "Close menu"
        },
        dashboard: {
            stats: {
                employees: "Employees",
                today: "Today's Activity",
                todayBookings: "Today Bookings",
                pendingBookings: "Pending Bookings",
                revenue: "Monthly Revenue",
                noData: "No statistics available"
            },
            notifications: {
                account_upgraded_pro: "Account Upgraded to Pro",
                plan_updated_basic: "Plan Updated",
                plan_message_pro: "Congratulations! Your account has been upgraded to the Pro Plan. You can now manage up to 3 businesses.",
                plan_message_basic: "Your account has been switched to the Basic Plan. You are now limited to 1 business."
            },
            workingEmployees: "Working Employees",
            recentActivities: "Recent Activities",
            more: "more",
            min: "min",
            refresh: "Refresh",
            loading: "Loading...",
            actions: {
                addBooking: "Add Booking",
                onlineBooking: "Online Booking"
            },
            calendar: {
                title: "Today's Schedule",
                time: "Time",
                bookingsCount: "bookings today"
            },
            empty: {
                noEmployees: "No employees found. Please add employees.",
                noActivities: "No recent activities.",
                unassigned: "Pending Assignment"
            },
            greeting: "Hello, {name}",
            error: {
                loadFailed: "Could not load dashboard data. Please try again.",
                noServices: "No services found. Please add a service first.",
                noBookingCode: "No booking code found. Please contact your administrator."
            },
            shopName: {
                placeholder: "Enter salon name...",
                saveTitle: "Save",
                cancelTitle: "Cancel",
                editTitle: "Edit salon name",
                emptyError: "Salon name cannot be empty",
                saveError: "Could not save salon name. Please try again."
            },
            businessId: {
                label: "Business ID (share with staff)",
                copySuccess: "Business ID copied!",
                copyPrompt: "Copy this ID:"
            },
            statusOptions: {
                pending: "⏳ Pending",
                confirmed: "✅ Confirmed",
                completed: "🏁 Completed",
                cancelled: "❌ Cancelled"
            },
            addBooking: {
                validationName: "Please enter customer name and phone number",
                validationService: "Please select at least one service",
                validationEmployee: "Please select a staff member",
                validationBiz: "Business ID not found. Please log in again.",
                success: "✅ Booking created successfully!",
                errorOutsideHours: "Please choose a different time or check Business Hours in settings.",
                errorNoBiz: "Business not found. Please log out and log in again.",
                errorGeneric: "❌ Error:",
                selectEmployee: "-- Select staff member --"
            },
            onlineBooking: {
                validationName: "Please enter full name and phone number",
                success: "✅ Thank you for your booking! We will contact you to confirm shortly.",
                errorGeneric: "❌ Error:",
                errorNoService: "Could not place booking"
            },
            deleteEmployee: {
                confirm: "Are you sure you want to remove this employee?",
                success: "✅ Employee removed successfully!",
                errorPrefix: "❌ Error:",
                errorSuffix: "Could not remove employee"
            },
            updateStatus: {
                errorPrefix: "❌ Could not update:"
            },
            bookingDetail: {
                title: "Booking Details",
                customer: "Customer",
                phone: "Phone",
                service: "Service",
                people: "People",
                date: "Date",
                time: "Time",
                notes: "Notes",
                status: "Status",
                staff: "Staff",
                unassigned: "Unassigned",
                close: "Close",
                assign: "Assign Staff",
                save: "Save Changes",
                attachedImages: "Attached Images"
            },
            assignModal: {
                title: "Assign Staff",
                selectLabel: "Select staff member",
                unassigned: "— Unassigned —",
                willAssign: "✓ Will assign to:",
                cancel: "Cancel",
                confirm: "💾 Confirm Assignment",
                today: "Today",
                assignError: "❌ Assignment error:"
            },
            modals: {
                addBookingTitle: "Add New Booking",
                onlineBookingTitle: "Online Booking",
                labels: {
                    customerName: "Customer Name",
                    phone: "Phone Number",
                    email: "Email",
                    employee: "Staff",
                    service: "Service",
                    date: "Date",
                    time: "Time",
                    people: "People",
                    notes: "Notes",
                    attachPhotos: "Attach Reference Photos (Optional)"
                },
                placeholders: {
                    customerName: "Enter customer name...",
                    phone: "Enter phone number...",
                    email: "Enter email...",
                    notes: "Special requests..."
                },
                buttons: {
                    cancel: "Cancel",
                    submit: "Add Booking",
                    submitOnline: "Book Now",
                    addPhotosLimit: "+ Add Photos (Max 3)"
                },
                publicLink: {
                    title: "Public Booking Link",
                    description: "Share this link with your customers so they can book online by themselves.",
                    copyBtn: "Copy Link",
                    visitBtn: "Visit Page",
                    copySuccess: "Link copied to clipboard!"
                }
            }
        },
        onboarding: {
            welcome: "Welcome! 👋",
            subtitle: "To get started, create a new business or join an existing one.",
            loggedInAs: "Logged in as:",
            logout: "Log out",
            createCard: {
                title: "Create a New Business",
                desc: "Register your own business and become the owner. You can invite staff to join later.",
                action: "Get started"
            },
            joinCard: {
                title: "Enter Business Code",
                desc: "Already have an invite code from the business owner? Enter the code to join and work with the team.",
                action: "Enter code"
            },
            createForm: {
                title: "Create a New Business",
                nameLabel: "Business Name *",
                namePlaceholder: "e.g. ABC Hair Salon, XYZ Spa...",
                descLabel: "Description (optional)",
                descPlaceholder: "Short description of your business...",
                phoneLabel: "Phone",
                addressLabel: "Address",
                addressPlaceholder: "Business address",
                submitLoading: "Creating...",
                submitBtn: "Create Business",
                validationName: "Please enter a business name",
                success: "Business created successfully! Redirecting...",
                errorDefault: "Could not create business. Please try again."
            },
            joinForm: {
                title: "Enter Business Code",
                codeLabel: "Business Code / Business ID *",
                codePlaceholder: "Enter Business ID (24 chars) or short code",
                codeHint: "Enter the full Business ID (24 chars) or short code from the business owner",
                submitLoading: "Verifying...",
                submitBtn: "Join Business",
                validationCode: "Please enter a business code or Business ID",
                success: "Joined business successfully! Redirecting...",
                errorInvalid: "Invalid code",
                errorDefault: "Invalid or expired business code"
            },
            title: "Account Setup",
            createBusiness: "Create New Business",
            joinBusiness: "Join a Business",
            joinPlaceholder: "Enter Business ID...",
            joinBtn: "Join",
            joining: "Joining...",
            invalidId: "Invalid ID. Please check and try again.",
            joinSuccess: "Joined successfully!"
        },



        employees: {
            title: "Employee Management",
            add: "Add Employee",
            searchPlaceholder: "Search employees...",
            table: {
                name: "Name",
                position: "Position",
                status: "Status",
                actions: "Actions"
            },
            services: {
                deletedService: "Deleted Service",
                messages: {
                    enterName: "Please enter service name",
                    addSuccess: "Service added successfully!",
                    addOffline: "Cannot connect to server, saved to local storage",
                    confirmDelete: "Are you sure you want to delete this service?\nNote: Related bookings will not be deleted but will show default color.",
                    deleteOffline: "Cannot connect to server, deleted from local storage"
                }
            },
            roles: {
                owner: "Owner",
                manager: "Manager",
                staff: "Staff",
                receptionist: "Receptionist",
                admin: "Admin",
                customer: "Customer"
            },
            status: {
                active: "Active",
                inactive: "Inactive"
            },
            noResults: "No employees found",
            messages: {
                noPermissionAdd: "You do not have permission to add employees!",
                enterInfo: "Please enter full name and phone number!",
                addSuccess: "Employee added successfully!",
                addError: "Cannot add employee",
                noPermissionUpdate: "You do not have permission to update employees!",
                updateSuccess: "Employee updated successfully!",
                shiftUpdated: "Work shift updated successfully!",
                updateError: "Cannot update employee",
                noPermissionDelete: "You do not have permission to delete employees!",
                confirmDelete: "Are you sure you want to delete this employee?",
                cannotDeleteSelf: "You cannot delete yourself!",
                deleteSuccess: "Employee deleted successfully!",
                deleteError: "Cannot delete employee",
                noPermissionStatus: "You do not have permission to change employee status!",
                statusChanged: {
                    active: "Employee activated!",
                    inactive: "Employee deactivated!"
                },
                statusError: "Cannot change status",
                onlyOwnerCanAssignManager: "Only owner can assign Manager role!",
                roleAssigned: "Role assigned successfully!",
                roleError: "Cannot assign role",
                confirmDeleteMember: "Remove {name} from business?",
                removeMemberSuccess: "Employee removed",
                deleteErrorPrefix: "Error",
                roleUpdatedTo: "Role updated to"
            },
            stats: {
                total: "Total Employees",
                active: "Active",
                manager: "Manager",
                morning: "Morning Shift"
            },
            filters: {
                role: "Role:",
                shift: "Shift:",
                status: "Status:",
                searchBtn: "Search",
                allRoles: "All Roles",
                allShifts: "All Shifts",
                allStatuses: "All Statuses"
            },
            loading: "Loading data...",
            youBadge: "(You)",
            empty: {
                title: "No employees yet",
                hint1: "Share your <strong>Business ID</strong> so employees can join.",
                hint2: "Employees go to <strong>Account → Join Business</strong> and enter the Business ID."
            },
            detailAlert: {
                title: "Employee Details",
                name: "Name",
                email: "Email",
                phone: "Phone",
                role: "Role",
                shift: "Shift",
                joinedAt: "Joined"
            },
            modals: {
                addTitle: "Add New Employee",
                editTitle: "Edit Employee",
                shiftLabel: "Work Shift *",
                shiftEditTitle: "Edit Shift — ",
                shiftType: "Shift Type",
                shiftStartTime: "Start Time",
                shiftEndTime: "End Time",
                shiftPreview: "Shift Preview",
                saveShift: "Save Shift",
                cancel: "Cancel",
                update: "Update",
                staffOption: "Staff",
                managerOption: "Manager",
                labels: {
                    name: "Employee Name",
                    phone: "Phone Number",
                    role: "Role",
                    shift: "Shift"
                }
            },
            permissions: {
                title: "Permission Information",
                owner: {
                    title: "Salon Owner (Owner)",
                    perm1: "Manage all employees",
                    perm2: "Assign Manager role",
                    perm3: "Edit salon information",
                    perm4: "View all reports"
                },
                manager: {
                    title: "Manager",
                    perm1: "Manage employees (add/edit/delete)",
                    perm2: "Manage bookings",
                    perm3: "Manage services",
                    perm4: "View reports"
                },
                staff: {
                    title: "Staff",
                    perm1: "View employee list",
                    perm2: "Manage bookings",
                    perm3: "Cannot add/edit employees"
                }
            },
            shifts: {
                morning: "Morning Shift",
                afternoon: "Afternoon Shift",
                evening: "Evening Shift",
                night: "Night Shift",
                fullTime: "Full Time",
                partTime: "Part Time"
            }
        },
        bookings: {
            title: "Booking List",
            create: "New Booking",
            filter: {
                all: "All",
                pending: "Pending",
                confirmed: "Confirmed",
                completed: "Completed",
                cancelled: "Cancelled"
            },
            table: {
                customer: "Customer",
                service: "Service",
                date: "Date & Time",
                staff: "Staff",
                status: "Status",
                actions: "Actions"
            },
            empty: "No bookings found",
            unassigned: "Unassigned",
            messages: {
                updateOffline: "Cannot connect to server, local storage updated",
                confirmDelete: "Are you sure you want to delete this booking?",
                deleteOffline: "Cannot connect to server, deleted from local storage"
            },
            stats: {
                today: "Today",
                week: "This Week",
                month: "This Month",
                total: "Total",
                pending: "Pending",
                confirmed: "Confirmed",
                completed: "Completed",
                cancelled: "Cancelled"
            },
            filters: {
                time: "Time Range:",
                source: "Source:",
                status: "Status:",
                searchPlaceholder: "Search by name, phone, service...",
                reset: "Reset",
                options: {
                    today: "Today",
                    week: "Last 7 days",
                    month: "Last 30 days",
                    all: "All",
                    allSources: "All Sources",
                    online: "Online Booking",
                    manual: "Manual Booking",
                    allStatuses: "All Statuses"
                }
            },
            headers: {
                addService: "Add New Service",
                serviceList: "Service List",
                allBookings: "All Bookings",
                filteredResults: "Filtered Results"
            },
            serviceForm: {
                name: "Service Name",
                price: "Price (VND)",
                color: "Display Color",
                duration: "Estimated Duration",
                addBtn: "Add Service",
                closeBtn: "Close",
                description: "Service will appear on Dashboard and can be selected when creating booking"
            },
            hints: {
                emptyState: "Try changing filters or adding a new booking",
                autoAssign: "(Auto-assign on confirm)",
                goToDashboard: "Go to Dashboard to create booking"
            },
            actions: {
                viewDetails: "View Details",
                edit: "Edit",
                delete: "Delete Booking",
                updatePhone: "Update phone number:"
            },
            modals: {
                checkout: {
                    title: "Confirm Completion",
                    subtitle: "Record revenue before closing booking",
                    servicePrice: "Service Price",
                    tipAmount: "TIP Amount",
                    totalIncome: "Total Income",
                    confirmBtn: "Confirm Completion"
                }
            },
            summary: {
                title: "Summary Statistics",
                onlineBookings: "Online Bookings:",
                manualBookings: "Manual Bookings:",
                completionRate: "Completion Rate:",
                cancelRate: "Cancel Rate:"
            }
        },
        profile: {
            title: "User Profile",
            uploadTitle: "Change Avatar",
            labels: {
                fullName: "Full Name",
                address: "Address",
                phone: "Phone Number",
                dob: "Date of Birth",
                gender: "Gender",
                notUpdated: "Not updated"
            },
            buttons: {
                edit: "Edit Profile",
                cancel: "Cancel",
                save: "Save Changes",
                saving: "Saving..."
            },
            business: {
                title: "My Businesses",
                add: "Add New Business",
                role: "Owner"
            },
            messages: {
                success: "Profile updated successfully!",
                error: "Update failed!",
                genericError: "An error occurred"
            }
        },
        schedule: {
            title: "Work Schedule Manager",
            subtitle: "Assign work shifts to employees",
            dayView: "Day",
            weekView: "Week",
            date: "Date:",
            weekContaining: "Week containing:",
            addEmployee: "Add Employee to Schedule",
            save: "Save Schedule",
            saving: "Saving...",
            selectEmployee: "Select Employee",
            search: "Search employee name...",
            noMembers: "No employees yet. They need to enter the Business ID to join.",
            allAssigned: "All employees are already in today's schedule.",
            noSchedule: "No employees in schedule",
            noScheduleHint: "Click \"Add Employee to Schedule\" to start assigning shifts.",
            needJoin: "Employees need to enter the Business ID to join first.",
            applyAll: "Quick apply for all:",
            employee: "Employee",
            off: "Off",
            removeFromSchedule: "Remove from schedule",
            saveSuccess: "Saved {count} work schedules!",
            saveError: "Error saving schedule",
            loading: "Loading...",
            today: "Today",
            prevDay: "Previous day",
            nextDay: "Next day",
            prevWeek: "Previous week",
            nextWeek: "Next week",
            shifts: {
                morning: "Morning",
                afternoon: "Afternoon",
                evening: "Evening",
                fullday: "Full Day",
                off: "Off"
            }
        },
        customers: {
            title: "Customers",
            search: "Search customers...",
            add: "Add Customer",
            total: "Total Customers",
            new: "New (this month)",
            returning: "Returning",
            empty: "No customers yet",
            notFound: "Customer not found",
            loading: "Loading...",
            backToList: "← Back to List",
            search2: "Search by name or phone...",
            searchBtn: "Search",
            view: "View",
            noData: "No customers found.",
            contactInfo: "Contact Info",
            stats: "Stats",
            totalBookings: "Total Bookings",
            firstVisit: "First Visit",
            lastVisit2: "Last Visit",
            recentBookings: "Recent Bookings",
            bookingHistoryPlaceholder: "Booking history will be displayed here.",
            table: {
                name: "Name",
                phone: "Phone",
                email: "Email",
                bookings: "Bookings",
                lastVisit: "Last Visit",
                actions: "Actions"
            }
        },
        business: {
            settings: "Business Settings",
            name: "Business Name",
            phone: "Phone",
            email: "Email",
            address: "Address",
            hours: "Business Hours",
            save: "Save Changes",
            saving: "Saving...",
            saved: "Saved!",
            businessId: "Business ID",
            shareId: "Share this ID so employees can join",
            loading: "Loading...",
            logo: "Business Logo",
            uploadLogo: "Click to upload logo",
            uploadLogoHint: "JPG, PNG, WebP · Max 5MB",
            changeLogo: "📷 Change Logo",
            uploadingLogo: "Uploading...",
            onlineBookingPage: "Online Booking Page",
            footerMessage: "Footer Message",
            footerHint: "— shown at bottom of booking page",
            footerBlankHint: "Leave blank to auto-show your business phone number",
            businessHours: "Business Hours",
            open: "Open",
            closed: "Closed",
            to: "to",
            settingsUpdated: "Settings updated successfully!",
            settingsError: "Failed to update settings.",
            googleMapsHint: "Enter your Google Maps link so 5-star reviewers can leave a review directly. Business QR is generated automatically from Booking Code.",
            qrPrintHint: 'ℹ️ Print QR from Dashboard → "📱 QR Check-in" button to place at reception'
        },
        checkin: {
            title: "Check-in / Check-out",
            enterPhone: "Enter Phone Number",
            phoneHint: "Enter the phone number you used when booking",
            phonePlaceholder: "e.g. 0901234567",
            findBooking: "Find Booking",
            searching: "Searching...",
            bookingFound: "Booking Found!",
            walkIn: "Walk-in",
            walkInHint: "No booking found, but you can still check in as a walk-in.",
            checkinNow: "Check In Now",
            checkedIn: "Checked In!",
            checkoutHint: "When your service is complete, scan the QR again to check out and leave a review.",
            checkout: "Check Out & Review",
            noBooking: "No booking found for today with this phone number.",
            connectionError: "Connection error. Please try again.",
            scanAgain: "Scan Again",
            poweredBy: "Powered by Booking App"
        },
        review: {
            title: "Rate Your Experience",
            hint: "How was your experience at",
            selectStar: "Select a rating",
            terrible: "Terrible",
            bad: "Bad",
            average: "Average",
            good: "Good",
            excellent: "Excellent!",
            feedbackPlaceholder: "Additional feedback (optional)...",
            googleMapsHint: "A 5-star review will be shared on Google Maps for everyone to see!",
            submitGoogle: "Submit & Review on Google Maps",
            submit: "Submit Review",
            submitting: "Submitting...",
            thankyou: "Thank You!",
            thankyouMsg: "We have received your feedback and will keep improving.",
            seeYouAgain: "See you next time!",
            listTitle: "Customer Reviews",
            listSub: "Internal feedback from QR Check-out",
            noReviews: "No reviews yet",
            noReviewsHint: "Reviews will appear after customers check-out and rate.",
            reviews: "reviews",
            allRatings: "All ratings",
            staff: "Staff",
            service: "Service",
            copyLink: "Copy Link",
            printQR: "Print QR",
            qrTitle: "QR Check-in / Check-out",
            qrDesc: "Customers scan this QR code to check-in on arrival and check-out when done to leave a review.",
            linkCopied: "Link copied!"
        },

        notifications: {
            title: "Notifications",
            markAllRead: "✓ Read all",
            clearAll: "Clear all",
            enableBanner: "Enable push notifications for incoming bookings",
            enableBtn: "Turn on",
            empty: "No new notifications",
            action: "View details →",
            viewAll: "View all {count} notifications →",
            time: {
                justNow: "Just now",
                minsAgo: "{mins} mins ago",
                hoursAgo: "{hours} hours ago",
                daysAgo: "{days} days ago"
            }
        },
        common: {
            loading: "Loading...",
            refresh: "Refresh",
            export: "Export",
            na: "N/A"
        },
        roles: {
            owner: "Owner",
            manager: "Manager",
            staff: "Staff",
            receptionist: "Receptionist",
            admin: "Admin",
            customer: "Customer"
        },
        shifts: {
            morning: "Morning Shift",
            afternoon: "Afternoon Shift",
            evening: "Evening Shift",
            night: "Night Shift",
            fulltime: "Full Time",
            parttime: "Part Time"
        },
        services: {
            deletedService: "Deleted Service",
            messages: {
                enterName: "Please enter service name",
                addSuccess: "Service added successfully!",
                addOffline: "Cannot connect to server, saved to local storage",
                confirmDelete: "Are you sure you want to delete this service?\nNote: Related bookings will not be deleted but will show default color.",
                deleteOffline: "Cannot connect to server, deleted from local storage",
                updateSuccess: "Service updated successfully!",
                updateOffline: "Cannot connect to server, saved to local storage"
            }
        },
        earnings: {
            title: "Earnings",
            subtitle: "Track revenue and work statistics",
            chartTitle: "Earnings Trend",
            exportCSV: "Export CSV",
            today: "Today",
            week: "Last 7 days",
            month: "This month",
            custom: "Custom",
            from: "From",
            to: "To",
            totalBusinessRevenue: "Total Business Revenue",
            serviceRevenue: "Service Revenue",
            totalTip: "Total TIP",
            employeesWithRevenue: "Staff With Revenue",
            myTotalRevenue: "My Total Revenue",
            tip: "TIP Amount",
            completedServices: "Completed Services",
            fullStatsTitle: "All Staff Earnings Statistics",
            table: {
                index: "#",
                employee: "Employee",
                servicesCount: "Services",
                serviceRevenue: "Service Revenue",
                tip: "TIP",
                total: "Total Earnings",
                percentTotal: "% Total",
                grandTotal: "GRAND TOTAL"
            },
            noData: "No revenue data found for this period.",
            noDataHint1: "Mark bookings as completed and enter prices to see stats.",
            noStaffData: "You have no completed services in this period.",
            noStaffDataHint: "Earnings will be recorded when you complete bookings and enter prices."
        }
    }
};

// Available languages
const availableLanguages = [
    { code: 'vi', label: '🇻🇳 Tiếng Việt', shortLabel: '🇻🇳 VN' },
    { code: 'en', label: '🇺🇸 English', shortLabel: '🇺🇸 EN' }
];

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguageState] = useState(() => {
        // Only use saved preference - default is always English
        const saved = localStorage.getItem('appLanguage');
        return saved === 'vi' ? 'vi' : 'en';
    });

    useEffect(() => {
        localStorage.setItem('appLanguage', language);
    }, [language]);

    const getApiBaseUrl = () => {
        const isNative = typeof window !== 'undefined' && (window).Capacitor?.isNativePlatform?.();
        if (isNative) {
            return 'https://app.phanh.app/api';
        }
        if (typeof window !== 'undefined' && (window.location.hostname === 'phanh.app' || window.location.hostname === 'www.phanh.app')) {
            return 'https://app.phanh.app/api';
        }
        if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
            return 'http://localhost:5000/api';
        }
        return '/api';
    };

    // Sync language preference to backend (fire-and-forget)
    const syncLanguageToBackend = (lang) => {
        try {
            const token = localStorage.getItem('authToken');
            if (!token) return; // Not logged in, skip
            const API_BASE_URL = import.meta.env.VITE_API_URL || getApiBaseUrl();
            fetch(`${API_BASE_URL}/auth/me`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ language: lang })
            }).catch(() => {}); // Silent fail
        } catch (e) {
            // Ignore errors - this is best-effort
        }
    };

    // Direct set language function
    const setLanguage = (lang) => {
        if (availableLanguages.some(l => l.code === lang)) {
            setLanguageState(lang);
            syncLanguageToBackend(lang);
        }
    };

    const toggleLanguage = () => {
        setLanguageState(prev => {
            const newLang = prev === 'vi' ? 'en' : 'vi';
            syncLanguageToBackend(newLang);
            return newLang;
        });
    };

    // Helper to access nested keys like 'login.title'
    const t = (key) => {
        const keys = key.split('.');
        let value = translations[language];
        for (const k of keys) {
            value = value?.[k];
        }
        return value || key;
    };

    return (
        <LanguageContext.Provider value={{
            language,
            setLanguage,
            toggleLanguage,
            t,
            availableLanguages
        }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
